<main>
	<div *ngIf="env" class="modal">
		<div class="modal__container">
			<div class="modal__header">
				<h2 class="modal__title">{{titulo_modal}} <span *ngIf="carga">{{cardSelected}}</span></h2>
				<a (click)="show(false)" class="btn-close"><i class="material-icons">close</i></a>
			</div>
			<div *ngIf="!carga && !result" class="modal__body">
				<p *ngIf="modalError" [className]="!respuesta ? 'alert red' : 'alert green'">{{modalError}}</p>
				<div class="modal__form">
					<div *ngIf="new" class="modal__form">
						<label for="">Número</label>
						<input (keydown)="onlyNumber($event)" (paste)="onPaste($event)" (drop)="onDrop($event)" maxlength="20" (input)="onInputNgModel($event)" type="text" [(ngModel)]="nTarjeta">
					</div>
					<div *ngIf="!new" class="modal__form">
						<label for="">Número</label>
						<input numeric type="number" [(ngModel)]="nTarjeta" disabled>
					</div>
					<div *ngIf="!carga" class="modal__form">
						<label for="">Nombre</label>
						<input [(ngModel)]="nomTarjeta" maxlength="20" type="text" maxlength="25">
					</div>
					<button *ngIf="!new" (click)="favCard(nTarjeta, fav)" [className]="fav? 'active-fav' : ''">
						<i class="material-icons">grade</i>
						<p>Establecer como favorita</p>
					</button>
				</div>
			</div>
			<div *ngIf="result">
				<div class="modal__form">
					<p class="alert success">Compra éxitosa <br /> La recarga tardará unos minutos en acreditarse</p>
				</div>
				<div class="modal__form">
					<label for="">Fecha</label>
					<p>{{response.date}}</p>
				</div>
				<div class="modal__form">
					<label for="">Monto</label>
					<p>Q {{cardMonto | number : '1.2-2' : ''}}</p>
				</div>
				<div class="modal__form">
					<label for="">Número Tarjeta</label>
					<p>{{cardCompro}}</p>
				</div>
				<div class="modal__form">
					<label for="">Número de Referencia</label>
					<p>{{response.referenceNumber}}</p>
				</div>
				<div class="modal__form">
					<label for="">Número de autorización</label>
					<p>{{response.authorizationNumber}}</p>
				</div>
				<div class="modal__form">
					<label for="">Número de Auditoría</label>
					<p>{{response.auditNumber}}</p>
				</div>
				<div class="modal__form">
					<label for="">Resultado</label>
					<p>{{response.responseMessage}}</p>
				</div>
				<div class="modal__form">
					<label for=""></label>
					<p class="alert succes">(1) Pago Electrónicamente</p>
				</div>
			</div>
			<div class="modal__footer">
				<button class="btn btn-cancelar" (click)="show(false)" [disabled]="modalButton">Cerrar</button>

				<ng-container *ngIf="!carga && !result">
					<button *ngIf="!new && !loading" class="btn" (click)="confirmarDelete()"
						[disabled]="modalButton">Desafiliar</button>
					<button *ngIf="!new && !loading" class="btn" (click)="tagCard()" [disabled]="modalButton">Guardar</button>
				</ng-container>
				<button *ngIf="new && !loading" class="btn" (click)="addNewCard()" [disabled]="modalButton">Afiliar</button>
				<p *ngIf="error" class="alert red">Ingrese datos obligatorios</p>
				<div *ngIf="loading" class="lds-ring">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div>
		</div>
	</div>

	<app-solicitud [numCard]="this.dataRes.card?.numTarjeta" [nuevaSolicitud]="nuevaSolicitud"
		(closeModal)="nuevaSolicitud = $event"></app-solicitud>

	<section class="tarjetas">
		<app-aside [getData]="newCard" (loaded)="loaderOff($event)" (solici)="solicitud($event)"></app-aside>

		<div class="tarjetas__content">

			<div class="tarjetas__content__header">

				<div class="tabs__group">
					<button routerLinkActive="btn-active" routerLink="movimientos" class="btn ">Movimientos</button>
					<!-- 					<button routerLinkActive="btn-active" routerLink="ra" class="btn">Saldo Remoto</button>
					<button routerLinkActive="btn-active" routerLink="mandatos" class="btn">Productos</button> -->
					<button routerLinkActive="btn-active" routerLink="solicitudes" class="btn">Solicitudes</button>

				</div>

				<button routerLinkActive="btn-active" (click)="newCard()" class="btn btn-new">Afiliar medio de
					acceso</button>

			</div>

			<div class="tarjetas__content__content">
				<router-outlet></router-outlet>
			</div>

		</div>
	</section>
</main>